export const PATHS = {
  root: '/',
  dev: '/dev',
  signIn: '/sign-in',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  firstTimeLogin: '/send-code',
  resetPassword: '/reset-password',
  myAccount: '/my-accounts',

  home: '/home',
  detail: '/detail',
  create: '/create',
  update: '/update',
  form: '/form',

  homeMyAccounts: '/home/my-accounts',
  detailMyAccounts: '/detail/my-accounts',
  createMyAccounts: '/create/my-accounts',
  updateMyAccounts: '/update/my-accounts',

  homeMyProperties: '/home/my-properties',
  detailMyProperties: '/detail/my-properties',
  createMyProperties: '/create/my-properties',
  updateMyProperties: '/update/my-properties',

  homeCustomerService: '/home/customer-service',
  homeAssessment: '/home/assessment',
  homeUserSystemAccount: '/home/user-system-account',
  homeNotificationCenter: '/home/notification-center',

  formBOE571: '/form/boe-571-l',
  formBOE571Detail: '/form/boe-571-l/detail',

  homeTimesheet: '/home/manage-timesheet',
  homeEmployee: '/home/manage-employees',
  homeTable: '/home/manage-table',
  homeUser: '/home/manage-users',

  homeJobCodes: '/home/manage-table/jobcodes',
  homePhaseCodes: '/home/manage-table/phasecodes',
  homeTasks: '/home/manage-table/tasks',

  timesheetManagement: '/timesheet',
  applicationManagement: '/application',

  updateTimesheet: '/manage-timesheet/update',
  createTimesheet: '/manage-timesheet/create',
};
